import React, { useState } from 'react';
import { TYPE_COLORS } from './TypeBadge';

function TypeLegend() {
  const [expanded, setExpanded] = useState(true);
  const types = Object.keys(TYPE_COLORS);

  return (
    <div className="type-legend">
      <button
        type="button"
        className="type-legend-toggle"
        onClick={() => setExpanded(!expanded)}
        onTouchEnd={(e) => { e.preventDefault(); setExpanded(!expanded); }}
      >
        Type Legend {expanded ? '▲' : '▼'}
      </button>
      {expanded && (
        <div className="type-legend-grid">
          {types.map((type) => (
            <span
              key={type}
              className="type-badge"
              style={{ backgroundColor: TYPE_COLORS[type] }}
            >
              {type}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default TypeLegend;
